import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { getCaseTypes } from '../API/TdsatApi';
import { RequiredLabel } from 'features/loginTdsat/Signup';

const useStyles = makeStyles((theme) => ({
  label: {
    color: '#121212',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
  
}));

const CauseListTypeInput = ({
  value = '', 
  onChange, 
  required=false,
  size='medium', 
  type = 'MainCase', 
  isLabel = true, 
  isInlineLabel = true,
  label = 'Type',
  error = null,
  name = 'causelist_type',
  formControlStyles,
}) => {
  const classes = useStyles();

  const CAUSELIST_TYPE_CHOICES = ['Main Cause List', 'Supplementry Cause List', 'Vacation Cause List'];
  
  return (
    <>
      <FormControl required={required} fullWidth margin="none" variant="outlined" size={size} style={formControlStyles}>
        {isLabel && (
          isInlineLabel ? (
            <InputLabel id='causelist_type'>{label}</InputLabel>
          ) : (
            required ? (
              <RequiredLabel className={classes.label} label={label} />
            ) : (
              <Typography className={classes.label}>{label}</Typography>
            )
          )
        )}
        <Select
          name={name}
          value={value}
          onChange={onChange}
          labelId='causelist_type'
          label={isInlineLabel && label}
        >
          <MenuItem>Select</MenuItem>
          {CAUSELIST_TYPE_CHOICES?.map((item, index)=>{
            return (
              <MenuItem key={index} value={item}>{item}</MenuItem>
            )
          })}
        </Select>
        {error && (
          <FormHelperText style={{color:'red', margin:0}}>{error}</FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default CauseListTypeInput;
